export const SET_ADOPT_DATA = "SET_ADOPT_DATA";
export const ADOPT_SESSION_FETCHING_INIT = "ADOPT_SESSION_FETCHING_INIT";
export const ADOPT_REGNS_FETCHING_INIT = "ADOPT_REGNS_FETCHING_INIT";
export const ADOPT_SUMMARY_PLANS_FETCHING_INIT =
  "ADOPT_SUMMARY_PLANS_FETCHING_INIT";
